import styled from "styled-components";

export const Portait8Style = styled.div`
width: 100%;
height: 100%;
.flex-column {
	display: -webkit-flex;
	display: flex;
	-webkit-flex-direction: column;
	flex-direction: column;
	-webkit-align-items: center;
	align-items: center;
	-webkit-justify-content: center;
	justify-content: center;
}

.flex-row-center {
	display: -webkit-flex;
	display: flex;
	-webkit-flex-direction: row;
	flex-direction: row;
	-webkit-align-items: center;
	align-items: center;
	-webkit-justify-content: center;
	justify-content: center;
}

.flex-row-left {
	display: -webkit-flex;
	display: flex;
	-webkit-flex-direction: row;
	flex-direction: row;
	-webkit-align-items: center;
	align-items: center;
	-webkit-justify-content: left;
	justify-content: left;
}

.subflex-left {
	width: 100%;
	text-align: left;
}

.subflex-right {
	width: 100%;
	text-align: right;
}

.subflex-center {
	width: 100%;
	text-align: center;
}

.f-arial {
	font-family: Arial;
}

.f-helv {
	font-family: Helvetica;
}

.f-helvbold {
	font-family: HelveticaBold;
}

.f-black {
	color: #000;
}

.f-white {
	color: #FFFFFF;
}

.f-orange {
	color: #FF7D01; 
}

.f-blue {
	color: #0076FE;
}

.poster {
	position: relative;
	overflow: hidden !important;
}

.poster.sixteen-by-nine.lg {
	width: 1920px;
	height: 1080px;
}

.poster.sixteen-by-nine.sm {
	width: 560px;
	height: 315px;
}

.poster.nine-by-sixteen.lg {
	height: 100%;
	width: 100%;
}

.poster.nine-by-sixteen.sm {
	width: 171px;
	height: 304px;
}

.poster.one-by-one.lg {
	width: 1920px;
	height: 1920px;
}

.poster.one-by-one.sm {
	width: 310px;
	height: 310px;
}



.poster {
	background-color: #FFFFFF;
}

.text-wrapper {
	position: relative;
	width: 100%;
	max-height: 40%;
	overflow: hidden;
}

.poster.lg .img-container {
	position: relative;
	height: 700px;
	width: 700px;
	margin-top: 20%;
	border-radius: 50%;
	overflow: hidden;
}

.poster.sm .img-container {
	position: relative;
	height: 120px;
	width: 120px;
	margin-top: 20%;
	border-radius: 50%;
	overflow: hidden;
}

.poster.lg .img-container > img {
	height: 800px;
}

.poster.sm .img-container > img {
	height: 200px;
}

.text-wrapper > div {
	width: 100%;
}

.text-wrapper > div:not(:last-of-type) {
	position: relative;
}

/* FOR TESTING ONLY */

.f-lg {
	font-size: 58px;
}

.f-sm {
	margin-top: 50px;
	font-size: 42px;
}

.poster.sm .f-lg {
	font-size: 9px;
}

.poster.sm .f-sm {
	margin-top: 5px;
	font-size: 7px;
}
`;
